module.exports = __webpack_public_path__ + "static/img/youngIcon5.3909ba7c.png";